import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentService } from './environment.service';
import { PaginationRequest } from './models/pagination/pagination.request.model';
import { RequestHelper } from '@shared/helpers';

@Injectable({ providedIn: 'root' })
export class EcApiService {
    constructor(
        private http: HttpClient,
        private environmentService: EnvironmentService
    ) { }

    private get url(): string {
        return `${this.environmentService.getCurrentApiUrl()}`;
    }

    // ECs
    getEcs(req: PaginationRequest): Observable<any> {
        const options = RequestHelper.createRequestOption(req);
        return this.http.get(`${this.url}/ecs`, { params: options });
    }

    updateEc(data: any): Observable<any> {
        return this.http.put(`${this.url}/ecs`, data);
    }
}

